// import { useState, useEffect } from "react";
// import { auth, db } from "../firebase";
// import { doc, getDoc } from "firebase/firestore";

// function Header() {
//   const DEFAULT_AVATAR = "https://cdn-icons-png.flaticon.com/512/847/847969.png";

//   const [userData, setUserData] = useState({
//     firstName: "",
//     profilePic: DEFAULT_AVATAR,
//   });

//   useEffect(() => {
//     const unsubscribe = auth.onAuthStateChanged((user) => {
//       if (user) {
//         fetchUserData(user.uid);
//       }
//     });
//     return () => unsubscribe();
//   }, []);

//   const fetchUserData = async (userId) => {
//     const userRef = doc(db, "users", userId);
//     const userSnap = await getDoc(userRef);

//     if (userSnap.exists()) {
//       const data = userSnap.data();
//       setUserData({
//         firstName: data.firstName || "",
//         profilePic: data.profilePic || DEFAULT_AVATAR,
//       });
//     }
//   };

//   return (
//     <header className="flex items-center justify-end p-4 bg-white shadow-md fixed top-0 right-0 w-full md:w-auto md:static md:rounded-md">
//       <div className="flex items-center gap-3 md:gap-4">
//         <span className="text-gray-700 text-sm md:text-base font-medium truncate max-w-[120px] md:max-w-none">
//           Hello! {userData.firstName}
//         </span>
//         <img
//           src={userData.profilePic}
//           alt="Profile"
//           className="w-8 h-8 md:w-10 md:h-10 rounded-full object-cover border border-gray-300"
//         />
//       </div>
//     </header>
//   );
// }

// export default Header;
import { useState, useEffect } from "react";
import { auth, db } from "../firebase";
import { doc, getDoc } from "firebase/firestore";

function Header() {
  const DEFAULT_AVATAR = "https://cdn-icons-png.flaticon.com/512/847/847969.png";

  const [userData, setUserData] = useState(null);
  const [hover, setHover] = useState(false);

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(async (user) => {
      if (user && user.uid) {
        try {
          const userRef = doc(db, "users", user.uid);
          const userSnap = await getDoc(userRef);

          if (userSnap.exists()) {
            const data = userSnap.data();
            setUserData({
              firstName: data.firstName || "",
              email: user.email || "",
              profilePic: data.profilePic || DEFAULT_AVATAR,
              activePlan: data.activePlan || null,
              credits: data.credits || 0,
            });
          }
        } catch (error) {
          console.error("🔥 Header Firestore Error:", error.message);
        }
      } else {
        // 👇 Clear the userData on logout
        setUserData(null);
      }
    });

    return () => unsubscribe();
  });

  // Don't render header if no user data (logged out or loading)
  if (!userData) return null;

  const { firstName, email, profilePic, activePlan, credits } = userData;

  return (
    <header className="flex items-center justify-end gap-6 p-4 fixed top-0 right-0 w-full md:w-auto md:static md:rounded-md bg-white z-50 shadow-sm">
     
     
      <div className="flex items-center gap-4">
        <div className={`text-xs font-semibold px-3 py-1 rounded-full border shadow-sm ${
            activePlan === "gold"
              ? "bg-yellow-50 border-yellow-300 text-yellow-800"
              : activePlan === "standard"
              ? "bg-purple-50 border-purple-300 text-purple-800"
              : "bg-gray-50 border-gray-300 text-gray-600"
          }`}
        >
          {activePlan
            ? activePlan.charAt(0).toUpperCase() + activePlan.slice(1)
            : "Free"}
        </div>
        <div className="text-xs font-semibold px-3 py-1 bg-white border border-gray-200 rounded-full text-gray-800 shadow-sm">
          {credits || 0} Credits
        </div>
      </div>

      <div className="relative">
        <div
          className="flex items-center gap-3 cursor-pointer"
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
        >
          <div className="text-black text-right px-3 py-1 rounded-md">
            <span className="text-sm md:text-lg font-semibold block">
              {firstName}
            </span>
          </div>
          <img
            src={profilePic}
            alt="Profile"
            className="w-12 h-12 rounded-full border border-gray-300 shadow-md"
          />
        </div>

        {hover && (
          <div className="absolute right-0 mt-3 w-[320px] bg-[#F7F5FF] backdrop-blur-md rounded-lg shadow-xl p-5 border border-gray-300 transition-all duration-200">
            <div className="flex items-center gap-4">
              <img
                src={profilePic}
                alt="Profile"
                className="w-20 h-20 rounded-full border border-gray-300 shadow-lg"
              />
              <div>
                <p className="text-gray-900 font-bold text-xl">{firstName}</p>
                <p className="text-gray-700 text-sm truncate">{email}</p>
                <div className="mt-2 text-sm text-gray-600">
                  Plan: <span className="font-medium">
                    {activePlan ? activePlan.charAt(0).toUpperCase() + activePlan.slice(1) : "Free"}
                  </span>
                </div>
                <div className="text-sm text-gray-600">
                  Credits: <span className="font-medium">{credits || 0}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
